module.exports = __webpack_public_path__ + "files/OBSERVA4.31013cd02b8ee941937ddabbe58bd93d.zip";